import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { CoachSettingsGeneralFormController } from 'presentation/page/settings/coach-settings/coach-settings-general/coach-settings-general-form.controller';

@Injectable()
export class CoachSettingsGeneralCertificatesController {
	public baseI18n =
		'presentation.app.page.settings.coach.general.references.certificates';

	public calendarLocale$: Observable<any>;

	constructor(
		private _translateService: TranslateService,
		private _formController: CoachSettingsGeneralFormController
	) {
		this._initObservables();
	}

	private _initObservables() {
		this.calendarLocale$ = this._translateService.stream(
			'presentation.primeng.calendar'
		);
	}

	public addCertificate(form: FormGroup) {
		const certificatesArray = form.get('certificates') as FormArray;
		certificatesArray.push(
			this._formController.addReferenceGroup(form.get('newCertificate'))
		);
	}

	public removeCertificate(index: number, form) {
		const certificatesArray = form.get('certificates') as FormArray;
		certificatesArray.removeAt(index);
	}
}
